import BetaForm from "@/components/landing/BetaForm";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function Hero() {
  const { config } = useSiteConfig();
  const h = config?.landing?.hero || {};
  const stats = (config?.landing?.stats || []).slice(0, 4);
  const marquee = config?.landing?.marquee || [];

  return (
    <section
      id="top"
      data-testid="hero"
      className="relative pt-32 md:pt-40 lg:pt-48 pb-20 md:pb-28 overflow-hidden"
    >
      <div className="grain absolute inset-0 pointer-events-none" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6 md:gap-10">
        {/* Left meta */}
        <div className="col-span-12 lg:col-span-3 order-2 lg:order-1">
          <div className="flex lg:flex-col gap-6 lg:gap-10 lg:pt-4">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
                Manifiesto · 001
              </p>
              <p data-testid="hero-manifesto-intro" className="mt-3 text-sm text-ink/80 leading-relaxed max-w-xs">
                {h.manifesto_intro || "Una red social que respeta tu atención, recompensa tu creatividad y protege tu identidad."}
              </p>
            </div>
            <div className="hidden lg:block w-12 h-px bg-ink/20" />
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
                {h.beta_label || "Beta global"}
              </p>
              <p data-testid="hero-beta-text" className="mt-3 text-sm text-ink/80 whitespace-pre-line">
                {h.beta_text || "Acceso por invitación —\nQ3 2026"}
              </p>
            </div>
          </div>
        </div>

        {/* Center editorial headline */}
        <div className="col-span-12 lg:col-span-9 order-1 lg:order-2 reveal-child">
          <span className="inline-flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-coral">
            <span className="w-8 h-px bg-coral" />
            {h.eyebrow || "La nueva red social"}
          </span>

          <h1 data-testid="hero-title" className="mt-6 font-serif font-light leading-[0.92] tracking-tighter text-[14vw] sm:text-[12vw] lg:text-[10rem] xl:text-[12rem]">
            <span className="block">{h.title_top || "Tu tiempo"}</span>
            <span className="block italic text-coral">{h.title_bottom_italic || "tiene valor."}</span>
          </h1>

          <div className="mt-10 grid grid-cols-12 gap-6">
            <p data-testid="hero-subtitle" className="col-span-12 md:col-span-7 text-lg md:text-xl text-ink/80 leading-relaxed text-balance">
              {h.subtitle || "Ovamx es la red social que sustituye al ruido por sentido."}
            </p>
            <div className="col-span-12 md:col-span-5 md:pl-8 md:border-l hairline">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid">
                {h.positioning_label || "Posicionamiento 2026"}
              </p>
              <p data-testid="hero-positioning" className="mt-2 font-serif text-2xl md:text-3xl leading-tight">
                {h.positioning_text || "Construida para reemplazar a Facebook, no para imitarlo."}
              </p>
            </div>
          </div>

          <div id="cta" className="mt-12 md:mt-16">
            <BetaForm />
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-8 max-w-3xl">
            {stats.map((s, i) => (
              <div key={`${s.v}-${i}`} className="flex flex-col">
                <span className="font-serif text-4xl md:text-5xl leading-none">
                  {s.k}
                </span>
                <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink-mid">
                  {s.v}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom marquee */}
      {marquee.length > 0 && (
        <div className="mt-24 md:mt-32 border-y hairline overflow-hidden">
          <div className="marquee-track py-4 md:py-6">
            {Array.from({ length: 2 }).map((_, k) => (
              <div key={k} className="flex items-center gap-12 px-6 whitespace-nowrap">
                {marquee.map((t, i) => (
                  <span key={`${k}-${i}`} className="flex items-center gap-12">
                    <span className="font-serif italic text-4xl md:text-6xl text-ink/85">
                      {t}
                    </span>
                    <span className="text-coral text-2xl">✦</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
